import { render, staticRenderFns } from "./OdontogramConfirmDialog.vue?vue&type=template&id=3c24f495&scoped=true"
import script from "./OdontogramConfirmDialog.vue?vue&type=script&lang=js"
export * from "./OdontogramConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./OdontogramConfirmDialog.vue?vue&type=style&index=0&id=3c24f495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24f495",
  null
  
)

export default component.exports